import { getIntrinsicElementProps, slot } from "@fluentui/react-utilities";

import { InputSectionProps, InputSectionState } from "./InputSection.types";

export function useInputSectionState_unstable(props: InputSectionProps, ref: React.ForwardedRef<HTMLFieldSetElement>): InputSectionState {
  const {
    legend,
    description
  } = props;

  const root = slot.always(
    getIntrinsicElementProps('fieldset', {
      ...props,
      ref
    }),
    { elementType: 'fieldset' }
  );

  const descriptionShorthand = slot.optional(description, { elementType: 'aside' });
  const legendShorthand = slot.always(legend, { elementType: 'legend' });

  return {
    components: {
      root: 'fieldset',
      legend: 'legend',
      description: 'aside'
    },
    root,
    description: descriptionShorthand,
    legend: legendShorthand,
  }
}
